export default "__VITE_ASSET__Dnndvsuv__"